// extracted by mini-css-extract-plugin
module.exports = {"top":"StreamPlayer_top__3wioZ","container":"StreamPlayer_container__BZhs9"};